
const imageUrl = (title) => {
  return `/imgs/case/online/${title}.png`;
};

const data = {
  introduce: {
    img: imageUrl('introduce'),
    description: '云恋科技围绕客户统一对外、优化流程的发展目标，结合“港口+”、“互联网+”思维和服务意识，发挥信息科技对大宗散货一体化的抓手作用，打造以客户为中心的服务体系，实现以大宗散货为产品的电商功能，搭建某港口大宗散货电商平台总体框架，构建现代综合物流体系。'
  },
  method: imageUrl('method'),
  value: [
    {
      title: '支持多品种交易',
      img: imageUrl('value1'),
    },
    {
      title: '支持多种交易模式',
      img: imageUrl('value2'),
    },
    {
      title: '统一平台管理',
      img: imageUrl('value3'),
    },
    {
      title: '线上线下一体化管理',
      img: imageUrl('value4'),
    },
    {
      title: '完善的融资业务系统实现',
      img: imageUrl('value5'),
    },
    {
      title: '完善的硬件网络一体化',
      img: imageUrl('value6'),
    }
  ]
};

export default data;


// WEBPACK FOOTER //
// ./src/routes/Case/config/online.js